import styled from "@emotion/styled";
import { Text } from "styles/utility-components";

export const Box = styled.div(({ theme }) => ({
  borderColor: theme.colors.sysBorderDecorative,
  borderWidth: "1px",
  borderStyle: "solid",
  borderRadius: "8px",
  flexGrow: 1,
  padding: "24px",
  backgroundColor: theme.colors.sysBackgroundDefault,
  color: theme.colors.sysTextDefault,
}));

export const WidgetTitle = styled(Text)(({ theme }) => ({
  color: theme.colors.sysTextSecondary,
  fontWeight: "600",
}));

/**
 * @deprecated Don't use this, outside of homepage. Preferably this wouldn't be done at all, but the alternative is matching on the name
 */
export const DEFAULT_VIEW_IDS = {
  openOpportunities: "b568b291-4567-496f-bbf8-8165002f2ce5",
  upcomingContractExpiries: "c735a82a-4fea-4a97-84a8-7f9638e64c25",
};
